import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getHashtagDetailsKolList } from '@opm/services';
import { useEffect, useState } from 'react';

export function useHashtagDetailsKolList({ filter }: { filter: any }) {
  const [kolList, setKolList] = useState<any[]>([]);
  const [hasMoreKol, setHasMoreKol] = useState(true);
  const { wrapperCancelRequest, loading, loadingRef } = useCancelRequestHook({
    defaultLoading: true,
  });

  function request() {
    if (!filter?.hashtag) return;
    wrapperCancelRequest(getHashtagDetailsKolList, filter)
      .then(data => {
        const { list, total } = data || {};
        setKolList(prev => [...prev, ...(list || [])]);
        setHasMoreKol(
          list?.length > 0 && total > kolList?.length + list?.length,
        );
      })
      .catch(() => {});
  }

  useEffect(() => {
    console.log('filter :: ', filter);
    if (filter) {
      request();
    }
  }, [filter]);

  return {
    kolList,
    setKolList,
    hasMoreKol,
    setHasMoreKol,
    loading,
    loadingRef
  };
}
